import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18616374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-info" }
const _hoisted_2 = {
  key: 0,
  class: "footer-info__item"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "footer-info__item"
}
const _hoisted_5 = {
  key: 2,
  class: "footer-info__item ipc"
}
const _hoisted_6 = ["href"]

import { useMapGetters } from '@/hooks/Webhook/mapGetters'
import useI18nTl from '@/hooks/useI18nTl'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'FooterInfo',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Operation')

const { systemInfo } = useMapGetters('systemStore', ['systemInfo'])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(systemInfo).companyName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            href: _unref(systemInfo).companyUrl,
            target: "_blank"
          }, _toDisplayString(_ctx.$t('Operation.company')) + ": " + _toDisplayString(_unref(systemInfo).companyName), 9, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (_unref(systemInfo).companyAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('Operation.companyAddress')) + ": " + _toDisplayString(_unref(systemInfo).companyAddress), 1))
      : _createCommentVNode("", true),
    (_unref(systemInfo).ipcInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("a", {
            href: _unref(systemInfo).ipcURL,
            target: "_blank"
          }, _toDisplayString(_unref(systemInfo).ipcInfo), 9, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})